import { ERROR_CODES, PUBLIC_MESSAGES } from '@common/constants/messages';

/**
 * Mensagem de tela para erro de login (senha, provedor de identidade, vínculo).
 *
 * Sai sempre do dicionário pelo código (errorCode): o authenticator ainda responde algumas
 * recusas antigas com texto em inglês, que nunca pode chegar ao usuário. {provedor} vira o
 * nome do provedor (Google, LinkedIn...).
 *
 * @param {Object} error erro do axios
 * @param {String} [providerLabel] nome do provedor na tela
 * @returns {String}
 */
export function authErrorMessage(error, providerLabel) {
  const response = error && error.response;

  if (!response) return 'Não foi possível conectar. Verifique sua internet e tente de novo.';

  const errorCode = response.data && response.data.errorCode;

  if (errorCode && PUBLIC_MESSAGES[errorCode])
    return PUBLIC_MESSAGES[errorCode].replace(/\{provedor\}/g, providerLabel || 'esse provedor');

  if (response.status === 429) return PUBLIC_MESSAGES[ERROR_CODES.AUTH_TOO_MANY_ATTEMPTS];

  if (response.status === 401) return PUBLIC_MESSAGES[ERROR_CODES.AUTH_INVALID_CREDENTIALS];

  return 'Algo deu errado do nosso lado. Tente de novo em alguns instantes.';
}
